// extracted by mini-css-extract-plugin
export default {"dataGridContainer":"DeskDataTable_dataGridContainer__nLn01"};